module.exports = __webpack_public_path__ + "img/Superb_sword_04.39f85a70.png";